import { Chip, ChipProps, Popover, Stack } from '@mui/material';
import { ReactElement, useState } from 'react';
export const ChipGroup = ({
  labels,
  maxChips = 3,
  className,
  spacing = 1,
  icons,
  colors,
  color,
  ...chipProps
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const handlePopoverOpen = event => {
    setAnchorEl(event.currentTarget);
  };
  const handlePopoverClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const visibleChips = labels.slice(0, maxChips);
  const remainingChips = labels.slice(maxChips);
  const hasOverflow = remainingChips.length > 0;
  return <Stack direction="row" spacing={spacing} className={className}>
            {visibleChips.map((label, index) => <Chip key={index} label={label} {...chipProps} color={colors?.[index] ?? color} icon={icons?.[index]} />)}
            {hasOverflow && <>
                    <Chip label={`+${remainingChips.length}`} {...chipProps} color="default" icon={undefined} clickable onMouseEnter={handlePopoverOpen} onMouseLeave={handlePopoverClose} onClick={e => {
        e.stopPropagation();
        e.preventDefault();
      }} />
                    <Popover sx={{
        pointerEvents: 'none'
      }} open={open} anchorEl={anchorEl} anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left'
      }} transformOrigin={{
        vertical: 'top',
        horizontal: 'left'
      }} onClose={handlePopoverClose} disableRestoreFocus slotProps={{
        paper: {
          className: '!rounded-xl !max-w-lg !overflow-y-auto'
        }
      }}>
                        <Stack direction="row" gap={spacing} p={2} className="!flex-wrap" onMouseEnter={handlePopoverOpen} onMouseLeave={handlePopoverClose}>
                            {remainingChips.map((label, index) => <Chip key={index} label={label} {...chipProps} color={colors?.[maxChips + index] ?? color} icon={icons?.[maxChips + index]} />)}
                        </Stack>
                    </Popover>
                </>}
        </Stack>;
};